import exchangesRating from '../widgets/exchangesRating.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await exchangesRating.updateDynamicsData();
    });
}(jQuery));